import { Table } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getSingleLeaveAllocation } from "../../redux/rtk/features/leave/leaveSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

// Transform raw data to match table column structure
const transformData = (data) => {
  // If data is a single object, wrap it in an array
  const dataArray = Array.isArray(data) ? data : [data];
  return dataArray.map((item) => ({
    id: item.EmployeeId, // Use EmployeeId as the unique id
    leaveType: { leaveType: item.LeaveTypeName }, // Match render function expectation
    annualLeave: item.YearlyLimit,
    pendingLeaves: item.PendingLeave,
    monthlyLimit: item.MonthlyLimit, // Add MonthlyLimit
    usedLeave: item.UsedLeave, // Add UsedLeave
  }));
};

function CustomTable({ list }) {
  const [columnsToShow, setColumnsToShow] = useState([]);

  const columns = [
    {
      id: 1,
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
    },
    {
      id: 2,
      title: "Leave Type",
      dataIndex: "leaveType",
      key: "leaveType",
      render: (leaveType) =>
        leaveType?.leaveType ? leaveType.leaveType.toLowerCase() : "N/A",
    },
    {
      id: 3,
      title: "Total Leave",
      dataIndex: "annualLeave",
      key: "annualLeave",
    },
    {
      id: 4,
      title: "Pending Leaves",
      dataIndex: "pendingLeaves",
      key: "pendingLeaves",
    },
    {
      id: 5,
      title: "Monthly Limit",
      dataIndex: "monthlyLimit",
      key: "monthlyLimit",
    },
    {
      id: 6,
      title: "Used Leave",
      dataIndex: "usedLeave",
      key: "usedLeave",
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  // Add a `key` and `serial` property to each item for rendering in the table
  const addKeys = (arr) =>
    arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

  // Transform the list before passing to dataSource
  const transformedList = list ? transformData(list) : [];

  return (
    <div className="ant-card p-4 rounded mt-5">
      <Table
        className="text-center"
        scroll={{ x: true }}
        columns={columnsToShow}
        dataSource={addKeys(transformedList)}
      />
    </div>
  );
}

const LeaveAllocation = () => {
  const { id } = useParams();
  const EmployeeId = getUserFromToken();
//   const EmployeeId = 6;

  const dispatch = useDispatch();
  const list = useSelector((state) => state.leave.leave);
  // console.log("allocate>>>>>", list);

  useEffect(() => {
    dispatch(getSingleLeaveAllocation(EmployeeId));
  }, [EmployeeId, dispatch]);

  return (
    // <UserPrivateComponent permission={"readSingle-leaveApplication"}>
    <div className="card">
      <div className="card-body">
        <CustomTable list={list} />
      </div>
    </div>
    // </UserPrivateComponent>
  );
};

export default LeaveAllocation;